export const removeKeys = <T extends Record<string, any>>(data: T, keyToRemove: keyof T | (keyof T)[]): T => {
    if (Array.isArray(keyToRemove)) {
        const updatedObj = keyToRemove.reduce<Record<string, any>>((acc, key) => {
            const { [key]: _, ...newObj } = acc;
            return newObj;
        }, data);
        return updatedObj as T;
    }
    const { [keyToRemove]: _, ...newObj } = data;
    return newObj as T;
};